import React from 'react';
import './svg.css';

const ActivationIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.8553 6.74902L11.1377 15.4666L7.26367 11.5915" stroke="#282828" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19.9419 9.82045C21.0208 13.7475 19.0665 17.8732 15.3446 19.5263C11.6226 21.1793 7.25132 19.8628 5.06124 16.4293C2.87116 12.9958 3.52037 8.47696 6.5885 5.79888C9.65662 3.12081 14.2217 3.08822 17.3278 5.7222" stroke="#282828" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ActivationIcon;